
export default function PlanGridContainer({ children }: { children: JSX.Element }) {
    return (<>
        {children}
    </>
    )
}